import React, { useState } from "react";
import "./CustomerSupport.css"; // Import external CSS for styling

const SupportPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Your support request has been submitted!");
    // You can integrate API call here to send data to backend
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="support-container">
      <h2>Customer Support</h2>
      <p>Need help? Fill out the form below, and we’ll get back to you soon!</p>

      <form onSubmit={handleSubmit} className="support-form">
        <label>Name:</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />

        <label>Email:</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

        <label>Message:</label>
        <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default SupportPage;
